import { LoyaltyMembershipLoader } from 'components/LoyaltyMembership/LoyaltyMembershipLoader'
import { LoyaltyMembershipPage } from 'components/LoyaltyMembership/LoyaltyMembershipPage'
import { Meta } from 'components/Meta/Meta'
import { useLogin } from 'hooks/useLogin'
import { NextPage } from 'next'
import React from 'react'

interface Props {
  venueSlug: string
}

const LoyaltyMembership: NextPage<Props> = ({ venueSlug }) => {
  const { currentUser } = useLogin()
  if (!currentUser) return <LoyaltyMembershipLoader />

  return (
    <>
      <Meta title="Membership - me&u" />
      <LoyaltyMembershipPage user={currentUser} venueSlug={venueSlug} />
    </>
  )
}

LoyaltyMembership.getInitialProps = (ctx) => {
  const venueSlug = String(ctx.query.venueSlug).toLowerCase()

  return { venueSlug }
}

export default LoyaltyMembership
